/*eslint-disable multiline-ternary */
import React, { useEffect, useState } from 'react';
import { Button, Card, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
//import { Loader } from 'semantic-ui-react'
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';
import './FindCare.scss';
import { ResourcesCard } from 'src/Member/components/Resources/ResourcesCard';
import MasterPermissions from 'src/Member/api/MasterPermissions';
import Skeleton from './Skeleton';
import { useTranslation } from 'react-i18next';
import GenericButton from '../../../../Components/GenericButton/GenericButton';
import { useSelector } from 'react-redux';

function FindCare({ findCareWidgetMode }) {
  const [linksList, setLinksList] = useState([]);
  const [loader, setLoader] = useState(false);
  const user = useSelector((state) => state?.user?.userData || {});
  //const displayViewAll = 5;
  const { t } = useTranslation();

  useEffect(() => {
    setLoader(true);

    const getFindCareLinks = async () => {
      const oidParams = `${'memberoid'}/${user?.MemberDetails?.MemberOID}`;
      const userTypeParams = `membertype/${user?.MemberDetails?.MemberType}`;

      const paramString = `/DisplayOnDashboard/true/ResourceGroupNumber/4/${userTypeParams}/${oidParams}`;

      return await axiosInstance.get(
        `${APIEndpoints.searchResourceResource()}${paramString}`,
      );
    };

    (async () => {
      try {
        const linksData = await getFindCareLinks();
        const linksList = linksData?.data?.Response?.Resources;
        if (linksList) setLinksList(linksList);
      } catch (e) {
        console.log('Error in fetching find provider links', e);
      } finally {
        setLoader(false);
      }
    })();
  }, [user?.MemberDetails?.MemberOID]);

  if (
    !MasterPermissions.CheckPermission('Access to Find Provider Tool') &&
    linksList?.length === 0
  ) {
    return null;
  }

  return (
    (MasterPermissions.CheckPermission('Access to Find Provider Tool') ||
      MasterPermissions.CheckPermission('Access Network Links')) && (
      <Col className="col-md-4 margin-bottom-32">
        <Card className="find-care-container">
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="find-care-title">
              {t('member.dashboard.findcare.title')}
            </h3>

            {MasterPermissions.CheckPermission('Access Network Links') && (
              <Link
                to={{
                  pathname: '/member/allresources',
                  category: 'findProviderCategory',
                }}
                //push={true}
                aria-label="view all providers"
                className="view-all-providers"
              >
                {t('member.dashboard.findcare.view_all')}
              </Link>
            )}
          </div>
          {MasterPermissions.CheckPermission(
            'Access to Find Provider Tool',
          ) && (
            <div className="find-provider">
              {(findCareWidgetMode === 0 || findCareWidgetMode === 2) && (
                <Link to="/member/find-provider" aria-label="find a provider">
                  <GenericButton
                    className="provider-button"
                    variant="secondary"
                    tabIndex={-1}
                  >
                    {t('member.dashboard.findcare.find_provider')}
                  </GenericButton>
                </Link>
              )}
            </div>
          )}
          {MasterPermissions.CheckPermission('Access Network Links') && (
            <div className="find-care">
              <Card.Body className="find-care-card-body">
                {(findCareWidgetMode === 1 || findCareWidgetMode === 2) && (
                  <>
                    {loader && (
                      <Skeleton count={findCareWidgetMode === 1 ? 5 : 3} />
                    )}
                    {!loader && (
                      <div
                        className={
                          findCareWidgetMode === 2
                            ? 'find-care-info-both'
                            : 'find-care-info'
                        }
                      >
                        <div className="dashboard-data-space-view-providerLinks">
                          <ResourcesCard
                            data={linksList}
                            truncateResourceTitle
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </Card.Body>
            </div>
          )}
        </Card>
      </Col>
    )
  );
}

export default FindCare;
